import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { RCA_STATUSES } from "constants/constants";
import { Button } from "@mui/material";
import Check from "@mui/icons-material/Check";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import useRolesPermissions from "hooks/useRolesPermissions";
import { ActionPlanEntity } from "entities/RCA/ActionPlanEntity/ActionPlanEntity";
import { UserContext } from "contexts/UserContext/UserContext";
import { RCADashboardContext } from "contexts/RCADashboardContext/RCADashboardContext";

const ActionPlanApprovalButton = ({
    actionPlan,
    refetch,
}: {
    actionPlan: IActionPlan;
    refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>;
}) => {
    const { t } = useTranslation();
    const { updateActionPlanMutation } = ActionPlanEntity.UpdateActionPlan();
    const { user_id } = useContext(UserContext);
    const { refetchUserActionPlans } = useContext(RCADashboardContext);
    const { RCA_PERMISSIONS } = useRolesPermissions();

    return (
        <Button
            variant="contained"
            disabled={!RCA_PERMISSIONS?.dashboard?.canApproveActionPlans}
            color="info"
            onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await updateActionPlanMutation({
                    variables: {
                        actionPlanId: actionPlan.action_plan_id,
                        changes: {
                            status_id: RCA_STATUSES.NOT_STARTED,
                            approved_on: new Date(),
                            approver_id: user_id!,
                        },
                    },
                });
                await refetch();
                await refetchUserActionPlans();
            }}
        >
            <Check /> {t("rca.rca_dashboard.approve")}
        </Button>
    );
};

export default ActionPlanApprovalButton;
